'use client';

import styled, { keyframes } from 'styled-components';
import { COLORS } from '@/constants/colors';

interface LoadingOverlayProps {
  loading: boolean;
  size?: number;
}

export default function LoadingOverlay({ loading, size = 150 }: LoadingOverlayProps) {
  if (!loading) return null;

  return (
    <>
      <LoadingBackdrop />
      <LoadingSpinner $size={size}>
        <Spinner $size={size} />
      </LoadingSpinner>
    </>
  );
}

const LoadingBackdrop = styled.div`
  top: 0;
  left: 0;
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgb(64 57 57 / 20%);
  backdrop-filter: blur(3px);
  z-index: 9999;
`;

const LoadingSpinner = styled.div<{ $size: number }>`
  display: block;
  margin: 0 auto;
  z-index: 10000;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div<{ $size: number }>`
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  border: ${props => Math.max(8, props.$size / 15)}px solid rgba(0, 173, 35, 0.1);
  border-top: ${props => Math.max(8, props.$size / 15)}px solid ${COLORS.brandGreen};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;
